// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iv-container {
    align-content: center;
    padding: 15px 0;
}

.iv-img-box {
    display: flex;
    justify-content: center;
    height: 213px;
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 16px;
    width: 100%;
}

.iv-img-box img {
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

@media (max-width: 1600px) {
    .iv-img-box {
        height: 185px
    }
}

.iv-title {
    margin: 4px 0 0;
    font-weight: 400;
    color: #0f062b;
    font-size: 16px;
}

.iv-dots {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #000000a2;
    display: flex;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 2px 10px;
    border-radius: 5px 10px;

}

.iv-dots button {
    background-color: transparent;
    display: flex;
    align-items: center;
    -moz-column-gap: 5px;
         column-gap: 5px;
    border: none;
}

.iv-dots button span {
    color: #fff;
    font-size: 17px !important;
}

@media (max-width: 1400px) {

    .iv-dots {
        position: absolute;
        top: 5px;
        right: 5px;

    }

    .iv-dots button span {
        font-size: 15px !important;
    }
}

.iv-filter > select {
    height: 50px;
    font-size: 15px;
}

.iv-filter > label {
    position: absolute;
    font-size: 15px;
    left: 30px;
    top: 15px;
    color: #878787;
}

.iv-filter button span {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #555;
    display: inline-block;
}

.iv-filter button {
    position: absolute;
    transform: translateY(-50%);
    right: 16px;
    top: 25px;
    width: 50px;
    background-color: #f5f7f6;
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/interactive-videos-dialog/interactive-videos-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;;AAE3B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;;IAEI;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;;IAEd;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B","sourcesContent":[".iv-container {\n    align-content: center;\n    padding: 15px 0;\n}\n\n.iv-img-box {\n    display: flex;\n    justify-content: center;\n    height: 213px;\n    position: relative;\n    overflow: hidden;\n    background: #f8f9fa;\n    border-radius: 16px;\n    width: 100%;\n}\n\n.iv-img-box img {\n    height: 100%;\n    object-fit: cover;\n    cursor: pointer;\n}\n\n@media (max-width: 1600px) {\n    .iv-img-box {\n        height: 185px\n    }\n}\n\n.iv-title {\n    margin: 4px 0 0;\n    font-weight: 400;\n    color: #0f062b;\n    font-size: 16px;\n}\n\n.iv-dots {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #000000a2;\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n    padding: 2px 10px;\n    border-radius: 5px 10px;\n\n}\n\n.iv-dots button {\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    column-gap: 5px;\n    border: none;\n}\n\n.iv-dots button span {\n    color: #fff;\n    font-size: 17px !important;\n}\n\n@media (max-width: 1400px) {\n\n    .iv-dots {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n\n    }\n\n    .iv-dots button span {\n        font-size: 15px !important;\n    }\n}\n\n.iv-filter > select {\n    height: 50px;\n    font-size: 15px;\n}\n\n.iv-filter > label {\n    position: absolute;\n    font-size: 15px;\n    left: 30px;\n    top: 15px;\n    color: #878787;\n}\n\n.iv-filter button span {\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 6px solid #555;\n    display: inline-block;\n}\n\n.iv-filter button {\n    position: absolute;\n    transform: translateY(-50%);\n    right: 16px;\n    top: 25px;\n    width: 50px;\n    background-color: #f5f7f6;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
